// extracted by mini-css-extract-plugin
export default {"floatingButton":"IU6EaPh9"};